import R from "ramda";
import { fieldValidator } from "src/components/Form/DynamicForm";

import validate from "validate.js";

validate.validators.custom = (value, options) => {
  if (!validate.isDefined(value)) {
    return;
  }
  if (!options.isValid(value)) {
    return validate.format(options.message, { value });
  }
};

validate.validators.optionalFormat = (value, options) => {
  if (value === "") {
    return null;
  }
  const message = validate.single(value, { format: options });

  if (message && message.length) {
    // Remove field name from message
    return message.map(msg => `^${msg}`);
  }

  return undefined;
};

/**
    Validation function for enforcing that n number of the provided fields
    are completed.
*/
export const requireNOfFields = (n, fields, formValues, t) => {
  const verificationErrors = R.reduce(
    (acc, key) => {
      if (R.isEmpty(formValues[key]) || R.isNil(formValues[key])) {
        return {
          ...acc,
          [key]: [t("olb.enrollment.fieldCountError", { n })],
        };
      }
      return acc;
    },
    {},
    fields
  );

  return R.keys(verificationErrors).length > n ? verificationErrors : {};
};

/* Merges a custom validators output with the result from the traditional field validator */
export const mergeWithFieldValidation = customValidator => (
  values,
  { t, fields, needsCaptcha }
) =>
  R.merge(
    fieldValidator(values, { t, fields, needsCaptcha }),
    customValidator(values, { t, fields, needsCaptcha })
  );



// WEBPACK FOOTER //
// ./src/components/Form/validation.js